module.exports = __webpack_public_path__ + "img/1437330515.a3040bd5.jpg";